/**
 * CandidateBadges — reusable source + score band badges
 * Used on pipeline board, dashboard candidate table, candidate profile.
 */

import type { CandidateSource, CandidateScoreBand } from '@/lib/contracts'
import { SOURCE_CONFIG, SCORE_BAND_CONFIG } from '@/lib/contracts'

export const SourceBadge = ({ source }: { source?: CandidateSource | string }) => {
  const key = (source ?? 'uploaded') as CandidateSource
  const config = SOURCE_CONFIG[key] ?? SOURCE_CONFIG.uploaded
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${config.bg} ${config.color}`}>
      {config.label}
    </span>
  )
}

export const ScoreBandBadge = ({ band }: { band?: CandidateScoreBand | string }) => {
  if (!band) return null
  const key = band as CandidateScoreBand
  const config = SCORE_BAND_CONFIG[key]
  if (!config) return null
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${config.bg} ${config.color} ${config.border}`}
      title={config.description}
    >
      {config.label}
    </span>
  )
}
